<template lang="pug">
  .norway
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/norway-min.png"
      )
      span {{ gettext('Норвегия') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content
      div
        p {{ gettext('Скандинавская страна лесистых гор, расположенная на севере от Дании и омываемая тремя морями и Атлантическим океаном. Норвежцы, коренные жители страны гордятся её первозданной красотой и завораживающей природой.') }}
        p {{ gettext('Норвегия – это небольшая страна с населением чуть больше 5 миллиона человек, которая находится на высокой и устойчивой позиции в мировой экономике. Норвежцы – одна из самых богатых наций на свете.') }}
        p {{ gettext('Это скромное по размерам государство обязано своим богатством в первую очередь залежам нефти и газа, которые добывают с Северного моря и ставят его на вторую позицию среди стран Европы по количеству экспортированной нефти. Норвегия также развивается в секторах лесного и сельского хозяйства, горно-перерабатывающей и бумажной индустрии, судостроения и рыбного промысла..') }}
        p {{ gettext('Норвегия ежегодно встречает иностранцев для сезонных работ по сбору урожая ягод, которых в лесах и на полях страны огромное множество, работы в рыбной индустрии (на судне, рыбных предприятиях), лесных хозяйствах (работа на специализированных машинах, работа с древесиной).') }}

        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
      div
        .about-boxes
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/visa-rules`")
            span {{ gettext('Visa rules') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/working-conditions`")
            span {{ gettext('Working conditions') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/accommodation`")
            span {{ gettext('Accommodation') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/healthcare`")
            span {{ gettext('Healthcare') }}

</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/norway-min.png'})
  },
  name: 'Norway',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Norway | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/norway/index.vue